module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-regular.8ddcafb9.eot";